import DataObjectField from "@/utilities/classes/data-object-field";
import { getPropertyValueOrDefault } from "@/utilities/functions";

const buildLoanReportsDataObject = (vData, document, documentName) => {
  const fields = [
    //new DataObjectField(vData.address, 6),
    new DataObjectField(vData.address.Street1, 7),
    new DataObjectField(vData.address.Street2, 8),
    new DataObjectField(vData.address.City, 9),
    new DataObjectField(vData.address.State, 10),
    new DataObjectField(vData.address.Zip, 11),
    new DataObjectField(vData.address.Country, 12),

     new DataObjectField(vData.ApplicantName, 805),
    // new DataObjectField(vData.email, 806),
    new DataObjectField(vData.email, 300),

    // Property Details
    new DataObjectField(vData.numOfUnits, 13),
    new DataObjectField(vData.ownershipTypeSelected, 14),
    new DataObjectField(vData.titleNames, 15),
    new DataObjectField(vData.rentalLicense, 16),
    new DataObjectField(vData.propertyInsurance, 17),
    new DataObjectField(vData.codeViolations, 18),
    new DataObjectField(vData.missedPayments, 19),
    new DataObjectField(vData.ssn, 20),
    new DataObjectField(vData.idTypeSelected, 21),
    new DataObjectField(vData.leadTest, 29),
    new DataObjectField(vData.heatTypeSelected, 1236),
    new DataObjectField(vData.waterHeatTypeSelected, 1237),

    // Loan Details
    new DataObjectField(vData.repairPlanningSelected, 60),
    new DataObjectField(vData.AmountOfProperties, 893),
    new DataObjectField(
      vData.buildSystemRepairtype.includes(
        "Are you planning repairs to building systems (HVAC, structural, mechanical, electrical, plumbing, fire protection)?"
      )
        ? "yes"
        : "no",
      1078
    ),
    new DataObjectField(
      vData.exteriorRepairtype.includes(
        "Are you planning repairs to the exterior of the building?"
      )
        ? "yes"
        : "no",
      1076
    ),
    new DataObjectField(
      vData.interiorRepairtype.includes(
        "Are you planning repairs to the interior of the building?"
      )
        ? "yes"
        : "no",
      1075
    ),
    new DataObjectField(
      vData.healthRepairtype.includes(
        "Are you planning to make health-related repairs or upgrades?"
      )
        ? "yes"
        : "no",
      1077
    ),

    // Cost Estimates
    new DataObjectField(vData.formData.drawingsPermitsCost, 57),
    new DataObjectField(vData.formData.constructionCost, 58),

    // Third Party Authorization
    new DataObjectField(vData.thirdPartyName, 1192),
    new DataObjectField(vData.thirdPartyTypeSelected, 1193),

    // Number isnt working only ext
    new DataObjectField(
      vData.thirdPartyExt != ""
        ? vData.thirdPartyNumber + "x" + vData.thirdPartyExt
        : vData.thirdPartyNumber,
      1194
    ),
    new DataObjectField(vData.thirdPartyOther, 1204),
    new DataObjectField(vData.thirdPartyEmail, 1195),

    // Consent and Submission
    new DataObjectField(vData.agreeToTerms, 292),
    new DataObjectField(vData.signature, 293),
    new DataObjectField(vData.appDate, 294),

    // Unit 1
    new DataObjectField(
      getPropertyValueOrDefault([0, "unitNumber"], vData.unitDetails),
      61
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "bedrooms"], vData.unitDetails),
      62
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isOccupied"], vData.unitDetails),
      64
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "needsRepair"], vData.unitDetails),
      65
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "ownerOccupied"], vData.unitDetails),
      816
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      602
    ),

    // Unit 2
    new DataObjectField(
      getPropertyValueOrDefault([1, "unitNumber"], vData.unitDetails),
      76
    ),
    new DataObjectField(
      getPropertyValueOrDefault([1, "bedrooms"], vData.unitDetails),
      77
    ),
    new DataObjectField(
      getPropertyValueOrDefault([1, "isOccupied"], vData.unitDetails),
      79
    ),
    new DataObjectField(
      getPropertyValueOrDefault([1, "needsRepair"], vData.unitDetails),
      80
    ),
    new DataObjectField(
      getPropertyValueOrDefault([1, "ownerOccupied"], vData.unitDetails),
      817
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      603
    ),

    // Unit 3
    new DataObjectField(
      getPropertyValueOrDefault([2, "unitNumber"], vData.unitDetails),
      91
    ),
    new DataObjectField(
      getPropertyValueOrDefault([2, "bedrooms"], vData.unitDetails),
      92
    ),
    new DataObjectField(
      getPropertyValueOrDefault([2, "isOccupied"], vData.unitDetails),
      94
    ),
    new DataObjectField(
      getPropertyValueOrDefault([2, "needsRepair"], vData.unitDetails),
      95
    ),
    new DataObjectField(
      getPropertyValueOrDefault([2, "ownerOccupied"], vData.unitDetails),
      818
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      604
    ),

    // Unit 4
    new DataObjectField(
      getPropertyValueOrDefault([3, "unitNumber"], vData.unitDetails),
      112
    ),
    new DataObjectField(
      getPropertyValueOrDefault([3, "bedrooms"], vData.unitDetails),
      113
    ),
    new DataObjectField(
      getPropertyValueOrDefault([3, "isOccupied"], vData.unitDetails),
      115
    ),
    new DataObjectField(
      getPropertyValueOrDefault([3, "needsRepair"], vData.unitDetails),
      116
    ),
    new DataObjectField(
      getPropertyValueOrDefault([3, "ownerOccupied"], vData.unitDetails),
      819
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      605
    ),

    // Unit 5
    new DataObjectField(
      getPropertyValueOrDefault([4, "unitNumber"], vData.unitDetails),
      127
    ),
    new DataObjectField(
      getPropertyValueOrDefault([4, "bedrooms"], vData.unitDetails),
      128
    ),
    new DataObjectField(
      getPropertyValueOrDefault([4, "isOccupied"], vData.unitDetails),
      130
    ),
    new DataObjectField(
      getPropertyValueOrDefault([4, "needsRepair"], vData.unitDetails),
      131
    ),
    new DataObjectField(
      getPropertyValueOrDefault([4, "ownerOccupied"], vData.unitDetails),
      820
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      606
    ),

    // Unit 6
    new DataObjectField(
      getPropertyValueOrDefault([5, "unitNumber"], vData.unitDetails),
      142
    ),
    new DataObjectField(
      getPropertyValueOrDefault([5, "bedrooms"], vData.unitDetails),
      143
    ),
    new DataObjectField(
      getPropertyValueOrDefault([5, "isOccupied"], vData.unitDetails),
      145
    ),
    new DataObjectField(
      getPropertyValueOrDefault([5, "needsRepair"], vData.unitDetails),
      146
    ),
    new DataObjectField(
      getPropertyValueOrDefault([5, "ownerOccupied"], vData.unitDetails),
      821
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      607
    ),

    // Unit 7
    new DataObjectField(
      getPropertyValueOrDefault([6, "unitNumber"], vData.unitDetails),
      157
    ),
    new DataObjectField(
      getPropertyValueOrDefault([6, "bedrooms"], vData.unitDetails),
      158
    ),
    new DataObjectField(
      getPropertyValueOrDefault([6, "isOccupied"], vData.unitDetails),
      160
    ),
    new DataObjectField(
      getPropertyValueOrDefault([6, "needsRepair"], vData.unitDetails),
      161
    ),
    new DataObjectField(
      getPropertyValueOrDefault([6, "ownerOccupied"], vData.unitDetails),
      822
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      608
    ),

    // Unit 8
    new DataObjectField(
      getPropertyValueOrDefault([7, "unitNumber"], vData.unitDetails),
      172
    ),
    new DataObjectField(
      getPropertyValueOrDefault([7, "bedrooms"], vData.unitDetails),
      173
    ),
    new DataObjectField(
      getPropertyValueOrDefault([7, "isOccupied"], vData.unitDetails),
      175
    ),
    new DataObjectField(
      getPropertyValueOrDefault([7, "needsRepair"], vData.unitDetails),
      176
    ),
    new DataObjectField(
      getPropertyValueOrDefault([7, "ownerOccupied"], vData.unitDetails),
      823
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      609
    ),

    // Unit 9
    new DataObjectField(
      getPropertyValueOrDefault([8, "unitNumber"], vData.unitDetails),
      187
    ),
    new DataObjectField(
      getPropertyValueOrDefault([8, "bedrooms"], vData.unitDetails),
      188
    ),
    new DataObjectField(
      getPropertyValueOrDefault([8, "isOccupied"], vData.unitDetails),
      190
    ),
    new DataObjectField(
      getPropertyValueOrDefault([8, "needsRepair"], vData.unitDetails),
      191
    ),
    new DataObjectField(
      getPropertyValueOrDefault([8, "ownerOccupied"], vData.unitDetails),
      824
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      610
    ),

    // Unit 10
    new DataObjectField(
      getPropertyValueOrDefault([9, "unitNumber"], vData.unitDetails),
      202
    ),
    new DataObjectField(
      getPropertyValueOrDefault([9, "bedrooms"], vData.unitDetails),
      203
    ),
    new DataObjectField(
      getPropertyValueOrDefault([9, "isOccupied"], vData.unitDetails),
      205
    ),
    new DataObjectField(
      getPropertyValueOrDefault([9, "needsRepair"], vData.unitDetails),
      206
    ),
    new DataObjectField(
      getPropertyValueOrDefault([9, "ownerOccupied"], vData.unitDetails),
      825
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      611
    ),

    // Unit 11
    new DataObjectField(
      getPropertyValueOrDefault([10, "unitNumber"], vData.unitDetails),
      217
    ),
    new DataObjectField(
      getPropertyValueOrDefault([10, "bedrooms"], vData.unitDetails),
      218
    ),
    new DataObjectField(
      getPropertyValueOrDefault([10, "isOccupied"], vData.unitDetails),
      220
    ),
    new DataObjectField(
      getPropertyValueOrDefault([10, "needsRepair"], vData.unitDetails),
      221
    ),
    new DataObjectField(
      getPropertyValueOrDefault([10, "ownerOccupied"], vData.unitDetails),
      826
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      612
    ),

    // Unit 12
    new DataObjectField(
      getPropertyValueOrDefault([11, "unitNumber"], vData.unitDetails),
      232
    ),
    new DataObjectField(
      getPropertyValueOrDefault([11, "bedrooms"], vData.unitDetails),
      233
    ),
    new DataObjectField(
      getPropertyValueOrDefault([11, "isOccupied"], vData.unitDetails),
      235
    ),
    new DataObjectField(
      getPropertyValueOrDefault([11, "needsRepair"], vData.unitDetails),
      236
    ),
    new DataObjectField(
      getPropertyValueOrDefault([11, "ownerOccupied"], vData.unitDetails),
      827
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      613
    ),

    // Unit 13
    new DataObjectField(
      getPropertyValueOrDefault([12, "unitNumber"], vData.unitDetails),
      247
    ),
    new DataObjectField(
      getPropertyValueOrDefault([12, "bedrooms"], vData.unitDetails),
      248
    ),
    new DataObjectField(
      getPropertyValueOrDefault([12, "isOccupied"], vData.unitDetails),
      250
    ),
    new DataObjectField(
      getPropertyValueOrDefault([12, "needsRepair"], vData.unitDetails),
      251
    ),
    new DataObjectField(
      getPropertyValueOrDefault([12, "ownerOccupied"], vData.unitDetails),
      828
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      614
    ),

    // Unit 14
    new DataObjectField(
      getPropertyValueOrDefault([13, "unitNumber"], vData.unitDetails),
      262
    ),
    new DataObjectField(
      getPropertyValueOrDefault([13, "bedrooms"], vData.unitDetails),
      263
    ),
    new DataObjectField(
      getPropertyValueOrDefault([13, "isOccupied"], vData.unitDetails),
      265
    ),
    new DataObjectField(
      getPropertyValueOrDefault([13, "needsRepair"], vData.unitDetails),
      266
    ),
    new DataObjectField(
      getPropertyValueOrDefault([13, "ownerOccupied"], vData.unitDetails),
      829
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      615
    ),

    // Unit 15
    new DataObjectField(
      getPropertyValueOrDefault([14, "unitNumber"], vData.unitDetails),
      277
    ),
    new DataObjectField(
      getPropertyValueOrDefault([14, "bedrooms"], vData.unitDetails),
      278
    ),
    new DataObjectField(
      getPropertyValueOrDefault([14, "isOccupied"], vData.unitDetails),
      280
    ),
    new DataObjectField(
      getPropertyValueOrDefault([14, "needsRepair"], vData.unitDetails),
      281
    ),
    new DataObjectField(
      getPropertyValueOrDefault([14, "ownerOccupied"], vData.unitDetails),
      830
    ),
    new DataObjectField(
      getPropertyValueOrDefault([0, "isVacant"], vData.unitDetails),
      616
    ),
    {
      _fid: "394",
      _filename: documentName,
      __text: document
    }
  ];

  const dataObject = {
    qdbapi: {
      udata: "_RIF_LOAN_REPORTS",
      apptoken: "d8phrhgbq4mmfwc3rkhnddciskd3",
      field: fields
    }
  };
  // console.log('DataObject fields:', dataObject.qdbapi.field.map(f => {
  //   // Return simple representation of each field
  //   if (f._fid) return { _fid: f._fid, filename: f._filename };
  //   return { id: f.id, value: f.value };
  // }));

  return dataObject;
};

export default buildLoanReportsDataObject;
